<script>
  import Likes from "./likes/Likes.vue";
  import UserTag from "../molecules/UserTag.vue";
  import { isContestExcluded } from "../../utils/contentTypeExcluded";
  import RowCard from "../molecules/rowCard.vue";

  export default {
    components: {
      UsersListVisor: () => import("../widgets/Modals/UsersListVisor.vue"),
      Likes,
      UserTag,
      RowCard,
    },
    props: ["participant", "award", "position", "idxCard", "canShowDetails", "competitionType", "className", "shape", "flipImage"],
    data() {
      return {
        showModalViewers: false,
        showModalLikes: false,
        isFlipped: false,
        showContent: true,
        flipTimeout: null,
        shapes: {
          vertical: "competition__card--monthly",
          rectangle: "",
        },
        participantMonitors: [],
        hiddenMonitorsCount: 0,
      };
    },
    computed: {
      isLessThan1024() {
        return this.$store.state.screen.width < 1024;
      },
      imgParticipant() {
        return this.participant?.internalPicture;
      },
      nameParticipant() {
        const { artisticName, user } = this.participant.user;
        return artisticName || user;
      },
      cityParticipant() {
        return this.participant.user.city;
      },
      awardImg() {
        return this.award && this.award?.logo;
      },
      participantViewers() {
        return this.participant?.viewers?.length ? this.participant.viewers.map(({ user, views }) => ({ ...user, views })) : [];
      },
      participantLikes() {
        return this.participant?.likes.length ? this.participant.likes.map((it) => it.userId) : [];
      },
      participantCommentsCount() {
        return this.participant?.comments.length;
      },
      userIsAdmin() {
        return this.$userData.role === "superadmin";
      },
      isContestTypeExcluded() {
        return isContestExcluded(this.competitionType);
      },
      getShape() {
        return this.shapes?.[this.shape];
      },
      isTipperContest() {
        return this.competitionType === "tipper";
      },
      monitorsToShow() {
        return this.participantMonitors;
      },
    },
    methods: {
      getMonitors() {
        const participantMonitors = [...this.participant?.monitors];
        if (this.isLessThan1024) {
          this.hiddenMonitorsCount = participantMonitors.length > 1 ? participantMonitors.length - 1 : 0;
          this.participantMonitors = participantMonitors.splice(0, 1);
          return;
        }
        this.participantMonitors = participantMonitors;
        this.hiddenMonitorsCount = 0;
      },
      getContestClasses(block) {
        return {
          [`competition__${block}--monthly`]: !this.isContestTypeExcluded,
          [`competition__${block}--tipper`]: this.isTipperContest,
        };
      },
      toggleFlip(state) {
        const duration = 300;
        if (this.flipTimeout) {
          clearTimeout(this.flipTimeout);
          this.flipTimeout = null;
        }
        this.isFlipped = state;
        this.flipTimeout = setTimeout(() => {
          this.showContent = true;
        }, duration);
      },
      showImgModal() {
        if (!this.canShowDetails) {
          return;
        }
        this.$emit("showModalDetails", this.participant, this.award);
      },
      showModal() {
        this.showModalViewers = !this.showModalViewers;
      },
      showLikesMd(event) {
        event.stopPropagation();
        this.showModalLikes = !this.showModalLikes;
      },
      scaleImage(scaleUp, id, action) {
        const competitionBuble = this.$refs[`bubbleitem_${id}`];
        if (action) {
          competitionBuble.style.transform = "scale(1.2)";
          competitionBuble.style.backgroundColor = "#000000bf";
        } else {
          competitionBuble.style.transform = "scale(1)";
          competitionBuble.style.backgroundColor = "#0000009c";
        }
      },
      handleMouseHover(event, id, state) {
        if (this.isTipperContest && !this.isLessThan1024) {
          this.showContent = false;
          this.toggleFlip(state);
          return;
        }
        this.scaleImage(event, id, state);
      },
    },
    mounted() {
      this.getMonitors();
    },
  };
</script>

<template>
  <article
    :class="`competition__card ${getShape} ${!showContent ? 'competition__card--flip' : ''}`"
    @mouseenter="($event) => handleMouseHover($event, participant._id, true)"
    @mouseleave="($event) => handleMouseHover($event, participant._id, false)">
    <transition name="fade-content">
      <div v-if="showContent" class="competition__awardContainerCard">
        <div :class="['competition__awardNameContainerCard', getContestClasses('awardNameContainerCard')]">
          <img v-if="awardImg" class="competition__awardCardImg" :src="awardImg" :alt="awardImg" />
          <div class="competition__nameCard" v-if="canShowDetails">
            <div :class="['competition__nameContainer', getContestClasses('nameContainer')]">
              <span class="competition__awardNameCard">{{ nameParticipant }}</span>
              <span class="competition__awardCityCard" v-if="isTipperContest"> - {{ cityParticipant }}</span>
            </div>
            <div :class="`competition__contentDetails ${isTipperContest ? 'competition__contentDetails--tipper' : ''}`">
              <img src="https://new-web-site-bucket.s3.amazonaws.com/myspace/concursos/Vector%20%283%29.svg" alt="tips icon" class="competition__tipsIcon" v-if="isTipperContest" />
              <span class="competition__tips" v-if="isTipperContest">{{ participant.tips }} USD</span>
              <span class="competition__awardCityCard" v-else>{{ cityParticipant }}</span>
              <UserTag v-if="isLessThan1024" class="competition__monitorCard" v-for="user in monitorsToShow" :key="user._id" :user="user" :showOnlyAvatar="true" modifier="card" />
              <div v-if="isLessThan1024 && hiddenMonitorsCount > 0" class="competition__monitorCardExtra">+{{ hiddenMonitorsCount }}</div>
            </div>
          </div>
        </div>
        <span class="competition__bubbleCard" :ref="'bubbleitem_' + participant._id">{{ position }}</span>
        <div
          :class="`competition__monitorsContainer ${!isContestTypeExcluded ? 'competition__monitorsContainer--monthly' : ''} ${isFlipped ? 'competition__monitorsContainer--flipped' : ''}`"
          v-if="!isLessThan1024">
          <UserTag
            class="competition__monitorCard"
            v-for="user in monitorsToShow"
            :key="user._id"
            :user="user"
            tooltipModifier="left"
            :showOnlyAvatar="true"
            modifier="card"
            :canShowTooltip="true"
            tooltipVariant="leftPosition" />
        </div>
        <div :class="[`competition__likesContainer ${participant.totalLikes > 0 ? 'competition__likesContainer--count' : ''}`, getContestClasses('likesContainer')]">
          <div class="competition__footerContainer" @click.prevent="showImgModal">
            <iconic name="commentContest" />
            <p class="competition__cantComments" v-if="participantCommentsCount">{{ participantCommentsCount }}</p>
          </div>
          <likes
            class="competition__likeCard"
            :likes="participant.likes"
            :totalLikes="participant.totalLikes"
            :postId="participant._id"
            nameEvent="likeParticipants"
            :modalaction="showLikesMd"
            v-if="canShowDetails" />
        </div>
        <div class="competition__views" @click.stop="showModal" v-if="participantViewers.length && userIsAdmin">
          <iconic class="competition__eye" name="eye_contets" />
          <p class="competition__cantViews">{{ participantViewers.length }}</p>
        </div>
      </div>
    </transition>
    <div class="competition__flipWrapper" :class="{ flipped: isFlipped }">
      <div class="competition__flipCard">
        <div
          :class="`competition__flipCardFace ${getShape} ${!isTipperContest ? 'competition__flipCardFace--notTipper' : ''}`"
          :style="imgParticipant ? { 'background-image': `url('${imgParticipant}')` } : {}"
          @click.prevent="showImgModal"></div>
        <div class="competition__flipCardFace competition__flipCardBack" @click.prevent="showImgModal">
          <img :src="flipImage" alt="imagen tips" class="competition__backImage" />
        </div>
      </div>
    </div>
    <UsersListVisor :users="participantLikes" :detail="'Usuarios que han dado like a la participante:'" :closeModal="showLikesMd" v-if="showModalLikes" />
    <UsersListVisor :users="participantViewers" :detail="'Usuarios que han visto la participante:'" :closeModal="showModal" v-if="showModalViewers" />
  </article>
</template>

<style lang="scss">
  .competition {
    &__card {
      position: relative;
      width: 100%;
      aspect-ratio: 4 / 3;
      border-radius: 10px;
      box-shadow: 0 1px 4px rgba(99, 99, 99, 0.6);
      cursor: pointer;
      overflow: hidden;
      transition: all 0.4s ease;
      &--monthly {
        aspect-ratio: 2.5 / 4;
      }
      &--flip {
        box-shadow: none;
      }
      &::after {
        content: "";
        position: absolute;
        height: 30%;
        width: 100%;
        bottom: 0;
        left: 0;
        border-radius: 0 0 10px 10px;
        background-image: linear-gradient(0deg, #020202c2 0%, rgba(15, 15, 15, 26%) 0%, rgba(19, 19, 19, 0));
      }
    }
    &__contentDetails {
      @include Flex(row);
      gap: 5px;
    }
    &__monitorCardExtra {
      @include Flex(center, center);
      width: 20px;
      height: 20px;
      border-radius: 50%;
      font-family: $sec_font;
      background: $primary-color;
      font-size: 11px;
      font-weight: bold;
      color: #fff;
    }
    &__views {
      @include Flex(row);
      color: $white;
      position: absolute;
      top: 10px;
      left: 12px;
      gap: 8px;
      padding: 0 6px;
      font-size: 12px;
      font-weight: 600;
      border-radius: 15px;
      background-color: rgba(0, 0, 0, 0.4);
      cursor: pointer;
      z-index: 3;
    }
    &__eye {
      font-size: 14px;
    }
    &__flipWrapper {
      perspective: 1000px;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;
      &.flipped .competition__flipCard {
        transform: rotateY(-180deg);
      }
    }
    &__flipCard {
      width: 100%;
      height: 100%;
      position: relative;
      transform-style: preserve-3d;
      transition: transform 0.3s ease;
    }
    &__flipCardFace {
      width: 100%;
      height: 100%;
      transform: scale(1.05);
      position: absolute;
      backface-visibility: hidden;
      background-size: cover;
      background-position: center;
      border-radius: 10px;
      &--notTipper {
        transition: transform 0.5s ease-in-out;
        &:hover {
          transform: scale(1.1);
        }
      }
    }
    &__flipCardBack {
      transform: rotateY(180deg);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    &__backImage {
      max-width: 100%;
      max-height: 100%;
      object-fit: cover;
      border-radius: 10px;
    }
    &__monitorsContainer {
      @include Flex(column, center, center);
      position: absolute;
      bottom: 23%;
      right: 10px;
      width: 10%;
      gap: $space-6;
      z-index: 11;
      &--flipped {
        bottom: 26%;
        transform: scale(1.2);
        right: 13px;
        gap: 4px;
      }
      &--monthly {
        bottom: 11%;
        right: 7px;
      }
    }
    &__monitorCard {
      .tooltipContainer {
        bottom: -3px;
      }
    }
    &__likesContainer {
      @include Flex(column-reverse, center, center);
      position: absolute;
      bottom: 9%;
      right: 10px;
      width: 10%;
      gap: $space-4;
      &--monthly {
        bottom: 4%;
      }
    }
    &__footerContainer {
      @include Flex(column);
      color: #fff;
      z-index: 3;
    }
    &__cantComments {
      font-family: $newFont_bold;
      font-size: 10px;
      text-shadow: 0px 1px 1.5px #000000ad;
    }
    &__cantViews {
      font-family: $newFont_regular;
    }
    &__awardContainerCard {
      position: relative;
      height: 100%;
      width: 100%;
    }
    &__nameContainer,
    &__tipsContainer {
      @include Flex(row);
      gap: 5px;
    }
    &__tipsContainer {
      gap: 4px;
    }
    &__nameContainer {
      &--tipper {
        height: 12px;
      }
    }
    &__tipsIcon {
      width: 15px;
      object-fit: cover;
    }
    &__tips {
      font-family: $sec_font;
      color: #e0be2c;
    }
    &__awardNameContainerCard {
      position: absolute;
      bottom: 0.8rem;
      left: 0.3rem;
      z-index: 10;
      @include Flex();
      gap: 10px;
      &--monthly {
        flex-direction: column;
        align-items: flex-start;
        gap: 5px;
      }
      &--tipper {
        bottom: 0.4rem;
      }
    }
    &__awardCardImg {
      @include Flex();
      width: 2.1rem;
      height: 2.1rem;
      color: #fff;
      &--monthly {
        width: 56px;
        height: 56px;
        margin-top: 10px;
      }
    }
    &__nameCard {
      @include Flex(column, flex-start, flex-start);
    }
    &__awardNameCard {
      font-family: $sec_font;
      font-size: 14px;
      color: #fff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-shadow: 0px 2px 3px rgba(0, 0, 0, 0.35);
    }
    &__awardCityCard {
      font-family: $newFont_regular;
      font-size: 12px;
      line-height: 10px;
      color: #fff;
      text-shadow: 0px 1px 2px rgba(0, 0, 0, 64%);
    }
    &__bubbleCard {
      font-family: $newFont_regular;
      position: absolute;
      right: 13px;
      top: 0.4rem;
      z-index: 10;
      @include Flex();
      align-self: flex-start;
      width: 25px;
      height: 25px;
      border-radius: 50%;
      background-color: #0000009c;
      color: #fff;
      font-weight: bold;
      font-size: 14px;
      transition: all 0.4s ease;
      box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.82);
      &:hover {
        background-color: $primary;
        transform: scale(1.2);
      }
    }
    &__likeCard {
      z-index: 2;
      .like__button {
        @include Flex(column);
        gap: $space-6;
      }
      .heart-bg {
        height: 10px;
      }
      .heart-icon {
        width: 55px;
        height: 55px;
      }
      .like__icoText {
        font-family: $newFont_bold;
        font-size: 10px;
        padding: unset;
        text-shadow: 0px 0px 2px #000000ad;
      }
    }
    &__likeCard > * {
      color: #0000009c;
    }
    @media (min-width: 500px) {
      &__awardNameCard {
        font-size: 20px;
      }
      &__nameContainer {
        &--tipper {
          height: 20px;
        }
      }
    }
    @media (min-width: 700px) {
      &__awardNameContainerCard {
        bottom: 8px;
        left: 0.8rem;
      }
      &__contentDetails {
        gap: 10px;
        &--tipper {
          gap: 4px;
        }
      }
      &__awardCityCard {
        font-size: 14px;
      }
    }
    @media (min-width: 768px) {
      &__likesContainer {
        @include Flex(row, flex-end, center);
        right: -3px;
        bottom: 5%;
        gap: $space-6;
        &--count {
          right: 12px;
        }
      }
      &__footerContainer {
        @include Flex(row);
        gap: $space-6;
      }
      &__cantComments {
        font-size: 14px;
      }
      &__likeCard {
        .like__button {
          @include Flex(row);
          gap: $space-0;
        }
        .like__icoText {
          font-size: 14px;
        }
        .heart-icon {
          width: 60px;
          height: 60px;
        }
      }
    }
    @media (min-width: 1024px) {
      &__likesContainer {
        bottom: 6%;
        &--monthly {
          bottom: 4%;
        }
        &--tipper {
          bottom: 5%;
        }
      }
      &__card {
        &--monthly {
          max-width: 330px;
        }
      }
    }
    .fade-content-enter-active,
    .fade-content-leave-active {
      transition: opacity 0.4s ease;
    }

    .fade-content-enter-from,
    .fade-content-leave-to {
      opacity: 0;
    }

    .fade-content-enter-to,
    .fade-content-leave-from {
      opacity: 1;
    }
  }
</style>
